import i18n from '@/i18n/i18n'
import MobileBannerService from '@/services/admin/MobileBannerService.js'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  mobileBanners: null,
  mobileBanner: {},
  audiences: []
}
export const mutations = {
  SET_MOBILE_BANNERS(state, mobileBanners) {
    state.mobileBanners = mobileBanners.data
    state.meta = mobileBanners.meta
  },
  SET_MOBILE_BANNER(state, mobileBanner) {
    state.mobileBanner = mobileBanner
  },
  SET_AUDIENCES(state, audiences) {
    state.audiences = audiences
  }
}

export const getters = {
  mobileBanners: state => state.mobileBanners
}

export const actions = {
  getMobileBanners({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      MobileBannerService.getMobileBanners()
        .then(response => {
          commit('SET_MOBILE_BANNERS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getMobileBanner({ commit }, id) {
    return new Promise((resolve, reject) => {
      MobileBannerService.getMobileBanner(id)
        .then(response => {
          commit('SET_MOBILE_BANNER', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getAudiencesFromFirebaseRemoteConfig({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      MobileBannerService.getAudiencesFromFirebaseRemoteConfig()
        .then(response => {
          commit('SET_AUDIENCES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteMobileBanner({ dispatch, commit, state }, params) {
    return new Promise((resolve, reject) => {
      MobileBannerService.deleteMobileBanner(params.id)
        .then(response => {
          commit('SET_MOBILE_BANNERS', response)
          const notification = {
            type: 'success',
            message: t('store.admin.mobile_banner.delete_mobile_banner_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createBanner({ dispatch, commit, state }, banner) {
    return new Promise((resolve, reject) => {
      MobileBannerService.createBanner(banner)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.mobile_banner.create_banner_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateBanner({ dispatch, commit, state }, banner) {
    return new Promise((resolve, reject) => {
      MobileBannerService.updateBanner(banner)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.mobile_banner.update_banner_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
